import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '../../useRefraQuery'

import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const useRefraManufacturersQuery = () => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'manufacturers',
    params: [],
    staleTime: Infinity,
    retry: false,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status

      logger
        .context('useRefraManufacturersQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching refractory manufacturers')

      spawnErrorToast(t('error.refraManufacturersQuery'))

      return false
    },
    select: (refraManufacturers) => refraManufacturers.sort((a, b) => a.name.localeCompare(b.name))
  })
}
